/**
 * Miroir de luniapp-backend/config/pageRegistry.js
 */
/** Au moins une de ces features → interface LuniApp V2 */
export const V2_ENTRY_FEATURE_NAMES = [
  "Option Eau",
  "Option Menage",
  "V2-GreenMiles",
];

export const PAGE_REGISTRY = [
  { pName: "dashboard-v2", featureNames: V2_ENTRY_FEATURE_NAMES },
  { pName: "greenmiles-v2", featureName: "V2-GreenMiles" },
  { pName: "actions-water-v2", featureName: "Option Eau" },
  { pName: "actions-cleaning-v2", featureName: "Option Menage" },
];

export const V2_OPTION_FEATURE_NAMES = ["Option Eau", "Option Menage"];

export function hotelHasV2Entry(features) {
  const names = Array.isArray(features) ? features : [];
  return V2_ENTRY_FEATURE_NAMES.some((featureName) => names.includes(featureName));
}
